import AuthenticatedResource from 'resources/AuthenticatedResource'

export default class SearchRewardInstanceResource extends AuthenticatedResource {
  static urlRoot = '/courses/:course_id/search_reward_instance' as const;

  readonly id: number | undefined = undefined;
  readonly order_id: number | undefined = undefined;
  readonly order_id_main: number | undefined = undefined;

  pk() {
    return this.id?.toString();
  }
}
